import { useState } from 'react';
import { useAppDispatch } from '../../../../../app/redux/hooks';
import { convertToEpoch } from '../../../../../utils/commonFunctions';

type EventType = {
  event: string;
  id: null | string;
  latitude: number;
  longitude: number;
  message: string;
  notificationId: string;
  notificationType: string;
  timestamp: number;
  userId: string;
  vehicleNumber: string;
};

export const useNotificationFunctionHooks = ({
  Events,
  allVehicleData,
  count,
  setCount,
  typeList,
  setGetStartDate,
  setGetEndDate,
  getStartDate,
  getEndDate,
  reset,
  urls,
  setTypeListEvent,
  isXs,
  setSideBarOpen,
  sidebarOpen,
  datas,
  setDatas
}: any) => {
  const dispatch = useAppDispatch();

  const [events, setEvents] = useState<any>(Events);
  const [typeLoad, setTypeLoad] = useState<any>('');
  const [view, setView] = useState<boolean>(false);

  const sideBarHandleCLick = () => {
    setSideBarOpen(!sidebarOpen);
  };

  const handleLoadMore = () => {
    dispatch(
      urls.getNotification({
        count: count + 6,
        events: typeList,
        startdate: convertToEpoch(getStartDate),
        enddate: convertToEpoch(getEndDate)
      })
    );
    setCount(count + 6);
    if (datas?.filter((item: any) => item?.active)?.length !== 1)
      setTypeLoad('Load More');
  };
  //submit
  const handleSubmitNotification = async (params: any) => {
    setDatas([]);
    setView(false);
    const searchEvents = events
      ?.filter((value: any, index: number) => value?.active === true)
      .map((value: any, index: number) => value.eventType.toString());
    const payload = {
      count: 6,
      events: searchEvents.toString(),
      startdate: convertToEpoch(params.startDate),
      enddate: convertToEpoch(params.endDate)
    };
    await dispatch(urls.getNotification(payload));
  };

  const handleViewOpen = (items: EventType) => {
    dispatch(urls.map([]));
    setTypeLoad('map-view');

    if (items?.latitude) setView(true);

    const [filteredMarker]: any = allVehicleData?.filter((value: any) => {
      return value.id === items?.vehicleNumber;
    });

    const convertedData = [items]?.map((item: any) => ({
      id: item?.vehicleNumber,
      lat: parseFloat(item?.latitude),
      lng: parseFloat(item?.longitude),
      type: filteredMarker?.type,
      name: filteredMarker?.type,
      status: item.event,
      info: {
        driverName: item?.driverName
      }
    }));
    let activeData = datas?.map((item: any) => ({
      ...item,
      active: item?.id === items?.id ? true : false
    }));
    setDatas(activeData);
    dispatch(urls?.selecedDatas(activeData));
    dispatch(urls?.map(convertedData));
    dispatch(urls?.center(convertedData));
    dispatch(urls?.zoom(convertedData));
  };

  const handleClickEvent = async (data: any, index: any) => {
    dispatch(urls?.clearNotification());
    setTypeLoad('');
    setCount(6);
    setTypeListEvent(data?.eventType);
    if (!isXs) {
      setSideBarOpen(false);
    }
    await dispatch(urls?.getNotification({ count: 6, events: data?.eventType }));
    setGetStartDate(null);
    reset();
    setGetEndDate(null);
    setEvents((prev: any) => {
      let newArr = prev.map((value: any, currentIndex: number) => ({
        ...value,
        active: currentIndex === index ? true : false
      }));
      return newArr;
    });
  };

  return {
    handleSubmitNotification,
    sideBarHandleCLick,
    handleViewOpen,
    handleClickEvent,
    handleLoadMore,
    sidebarOpen,
    events,
    datas,
    typeLoad,
    view
  };
};
